import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const TOKEN_KEY = "fa_token";

export const api = axios.create({ baseURL: `${BACKEND_URL}/api` });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function errMsg(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  return detail.msg || String(detail);
}

export function fileUrl(p) {
  if (!p) return "";
  if (p.startsWith("/api/")) return `${BACKEND_URL}${p}`;
  return p;
}

export const fmtDateTime = (s) =>
  s ? new Date(s).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" }) : "—";
export const fmtDate = (s) => (s ? new Date(s).toLocaleDateString(undefined, { dateStyle: "medium" }) : "—");
export const fmtTime = (s) => (s ? new Date(s).toLocaleTimeString(undefined, { timeStyle: "short" }) : "—");

export const initials = (n = "") =>
  n.replace("Dr. ", "").split(" ").map((x) => x[0]).slice(0, 2).join("").toUpperCase();
